const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const spaceSlugSearchSchema = z.object({
  edit: z.union([z.string(), z.boolean()]).optional().catch(undefined),
  preview: z.boolean().optional().catch(undefined),
  // Events list query params
  pastEvents: z.boolean().optional().catch(undefined),
  status: z.string().optional().catch(undefined),
  topics: z.union([z.string(), z.number()]).optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  iframe: z.boolean().optional().catch(undefined),
  message_id: z.coerce.number().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/_dynamicLayout/c/$spaceSlug")({
  validateSearch: spaceSlugSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});